$('[data-toggle="menu"]').click(function(){
	$($(this).attr('data-target')).toggleClass('open');
	$('body,html').toggleClass('lockscroll');
});